import z from 'zod';
import { firmIdValue, userIdValue, } from '../../subscription/value-objects/ids';
import { caseCalendarSchema } from '../value-objects/case-calendar';
import { caseStatusValue } from '../value-objects/case-status';
import { caseIdValue, clientIdValue, employeeIdValue, procedureIdValue, } from '../value-objects/ids';
/** Legal case (dossier) started from a catalog procedure. */
export const caseSchema = z.object({
    calendar: caseCalendarSchema.optional(),
    clientId: clientIdValue.optional(),
    closedAt: z.date().optional(),
    createdAt: z.date(),
    employeeId: employeeIdValue.optional(),
    firmId: firmIdValue,
    id: caseIdValue,
    procedureId: procedureIdValue,
    startDate: z.date().optional(),
    status: caseStatusValue,
    updatedAt: z.date(),
    userId: userIdValue,
});
export const casesSchema = z.array(caseSchema);
export const parseCase = (value) => caseSchema.parse(value);
export const isCase = (value) => caseSchema.safeParse(value).success;
//# sourceMappingURL=case.js.map